<div>
  <h2 class="ng-binding"><a href="#" #fleetLink [ecommerceRouterLink]="['/:lang/home/cart/myfleet']">My Fleet</a></h2>


  @if (hasError) {
    <mibp-system-message #msg [messageType]="msg.Types.Error" class="m-2">
      <p><mibp-resource-string key="Global_Error_OperationFailed_message"></mibp-resource-string></p>
    </mibp-system-message>
  }


  @if (!hasError) {
    <div style="display: flex">
      <div class="chart">
        <mibp-chart-pie [doughnut]="true" [loading]="isLoading" [data]="fleetChartData" width="250px" height="180px" [aspectRatio]="1.5"></mibp-chart-pie>
      </div>
      <div>
        <h3><mibp-resource-string key="MyFleet_Dashboard_TotalFleetStatus"></mibp-resource-string>: {{ fleetCount }}</h3>
        <ul class="fleet-status-list">
          <li><span class="fleet-status operational" (click)="activeInfo.open($event.target)"><mibp-resource-string key="MyFleet_Active"></mibp-resource-string> {{ fleetActiveCount }}</span></li>
          <li><span class="fleet-status inactive" (click)="inactiveInfo.open($event.target)"><mibp-resource-string key="MyFleet_Standby"></mibp-resource-string> {{ fleetStandbyCount }}</span></li>
        </ul>
        <div>
          <button type="button" class="my-button" (click)="fleetLink.click()"><mibp-resource-string key="Global_ShowMore"></mibp-resource-string></button>
        </div>
      </div>
    </div>
  }
</div>

<mibp-new-popover #activeInfo>
  <p><strong><mibp-resource-string key="MyFleet_Active"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_Active_Description"></mibp-resource-string></p>
</mibp-new-popover>

<mibp-new-popover #inactiveInfo>
  <p><strong><mibp-resource-string key="MyFleet_Standby"></mibp-resource-string></strong>: <mibp-resource-string key="MyFleet_Standby_Description"></mibp-resource-string></p>
</mibp-new-popover>

